import { get, post, axios } from './baseAxios';
import { API_PROMOTIONS } from '../utils/urls';

const url = API_PROMOTIONS;

export const getPromotion = (id) => get(`${url}/${id}`);

export const getPromotions = (params) => get(url, { params });

export const updatePromotion = (request) => post(url, request);

export const createPromotion = (request) => post(url, request);

export const deletePromotion = (id) => axios.delete(`${url}/${id}`);
